import React, { Component } from "react";
import PropTypes from "prop-types";
import List from "./InfiniteList.view";
import { withTranslation } from "react-i18next";

class ListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      hasMore: true,
      forceRefresData: false,
      pageSize: props.defaultPageSize ? props.defaultPageSize : 10,
      currentPage: 0,
      loading: true,
    };
  }

  componentDidMount() {
    this.refreshData(this.props.filters);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filters !== this.props.filters) {
      this.refreshData(this.props.filters);
    }
    if (
      prevProps.forceRefresh !== this.props.forceRefresh &&
      this.props.forceRefresh === true
    ) {
      this.setRefresData(this.props.forceRefresh);
    }
    if (
      prevProps.itemRefresh !== this.props.itemRefresh &&
      this.props.itemRefresh
    ) {
      this.refresItem(this.props.itemRefresh);
    }
    if (
      prevState.forceRefresData !== this.state.forceRefresData &&
      this.state.forceRefresData === true
    ) {
      this.refreshData(true);
    }
  }

  refresItem(item) {
    const { idItem } = this.props;
    if (this.state.data && this.state.data.length > 0) {
      const index = this.state.data.findIndex(
        (dat) => dat[idItem] === item[idItem]
      );
      if (index !== -1) {
        const newData = [...this.state.data];
        newData[index] = item;
        this.setState({ data: newData });
      }
    }
  }

  setRefresData(forceRefresh) {
    this.setState({ forceRefresData: forceRefresh });
  }

  refreshData(resetRefresh = false) {
    if (resetRefresh) {
      this.setRefresData(false);
    }
    this.fetchData(0);
  }

  async fetchData(pageIndex, pageSizeSeted) {
    const { pageSize } = this.state;
    let pageSizeFinal = 0;
    if (pageSizeSeted) {
      pageSizeFinal = pageSizeSeted;
    } else {
      pageSizeFinal = pageSize;
    }
    const filter = {
      page: pageIndex + 1,
      pageSize: pageSizeFinal || 10,
    };
    if (this.props.filters) {
      filter.filters = this.props.filters;
    }

    this.getData(filter);
  }

  async getData(filter) {
    const { toList } = this.props;
    if (toList) {
      const result = await toList(filter);
      let oldItems = [];
      if (filter.page > 1) {
        oldItems = [...this.state.data];
      }
      if (result && result.docs) {
        const finalItems = oldItems.concat(result.docs);

        this.setState({
          data: finalItems || [],
          currentPage: result.page,
          hasMore: result.hasNextPage,
        });
      }
    }
    this.setState({ loading: false });
  }

  getMoreData() {
    this.fetchData(this.state.currentPage);
  }

  getAddInList() {
    const { addNewItemInList } = this.props;
    if (addNewItemInList) {
      const newItem = [{ uuid: "NEW-ITEM" }];
      return newItem.concat(this.state.data || []);
    }

    return this.state.data;
  }

  render() {
    const {
      renderItem,
      t,
      title,
      formlinkToAdd,
      iconAdd,
      classNameLinkAdd,
      tbLoadingText,
      tbNoDataText,
      variantTitle,
      floatButton,
      variantIcon,
      endMessage,
      messageButtonMore,
      id,
      customClassName,
      variantButtonMore,
      headerComponentList,
      renderLoader,
      renderNewItemInList,
      addNewItemInList,
      customActionAdd,
      customAction,
      scrollableTarget,
      iconEmptyList,
    } = this.props;

    const { loading } = this.state;

    return (
      <List
        renderLoader={renderLoader || null}
        loading={loading}
        id={id}
        floatButton={floatButton}
        variantIcon={variantIcon}
        title={title}
        formlinkToAdd={formlinkToAdd}
        hasMore={this.state.hasMore}
        data={this.getAddInList() || []}
        getMoreData={() => this.getMoreData()}
        renderItem={renderItem}
        iconAdd={iconAdd}
        classNameLinkAdd={classNameLinkAdd}
        tbLoadingText={t(tbLoadingText || "generic.tables.loading")}
        tbNoDataText={t(tbNoDataText || "generic.tables.no_data")}
        variantTitle={variantTitle}
        endMessage={endMessage}
        messageButtonMore={messageButtonMore}
        customClassName={customClassName}
        variantButtonMore={variantButtonMore}
        headerComponentList={headerComponentList || null}
        renderNewItemInList={renderNewItemInList || null}
        addNewItemInList={addNewItemInList || false}
        customActionAdd={customActionAdd || false}
        customAction={customAction}
        scrollableTarget={scrollableTarget}
        iconEmptyList={iconEmptyList || "fas fa-bell-slash"}
      />
    );
  }
}

ListContainer.propTypes = {
  renderItem: PropTypes.func,
  title: PropTypes.string,
  formlinkToAdd: PropTypes.string,
  defaultPageSize: PropTypes.number,
  toList: PropTypes.func.isRequired,
  filters: PropTypes.object,
  forceRefresh: PropTypes.bool,
  iconAdd: PropTypes.string,
  classNameLinkAdd: PropTypes.string,
  tbLoadingText: PropTypes.string,
  tbNoDataText: PropTypes.string,
  variantTitle: PropTypes.string,
  floatButton: PropTypes.bool,
  variantIcon: PropTypes.string,
  endMessage: PropTypes.string,
  messageButtonMore: PropTypes.string,
  id: PropTypes.string,
  customClassName: PropTypes.string,
  variantButtonMore: PropTypes.string,
  headerComponentList: PropTypes.any,
  itemRefresh: PropTypes.object,
  idItem: PropTypes.string,
  renderLoader: PropTypes.func,
  addNewItemInList: PropTypes.bool,
  renderNewItemInList: PropTypes.func,
  customActionAdd: PropTypes.bool,
  customAction: PropTypes.func,
  scrollableTarget: PropTypes.string,
};

export default withTranslation()(ListContainer);
